<template>
  <v-container grid-list-md fluid class="p-0" style="padding-top: 0px;">
    <v-btn dark color="blue-grey darken-1" @click="dialogQuadroVisible = true">
      <v-icon dark class="mr-2">
        {{ this.translate("table.condominio_quadrosocietario.icon") }}
      </v-icon>
      {{ this.translate("table.condominio_quadrosocietario.title")[0] }}
    </v-btn>
    <!-- Dialog Quadro Societário -->
    <v-dialog v-model="dialogQuadroVisible" max-width="1600px" @input="dialog = false" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid class="p-0">
            <v-layout justify-start>
              <span class="display-1">{{ formTitle }}</span>
              <v-spacer></v-spacer>
              <v-btn v-if="!dialog" fab small @click="closeDialog()">
                <v-icon dark>
                  {{ this.translate("system.button.close.icon") }}
                </v-icon>
              </v-btn>
            </v-layout>
            <!--Index-->
            <v-layout v-if="!dialog" wrap align-center>
              <v-flex xs12 sm8>
                <v-btn
                  color="primary"
                  @click="create"
                  class="ml-0"
                  :disabled="!hasCondominioAccess('condominio_pessoa', 'create')"
                >
                  {{ this.translate("system.button.add.title") }}
                  <v-icon dark>
                    {{ this.translate("system.button.add.icon") }}
                  </v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  append-icon="search"
                  label="Pesquisar"
                  v-model="search"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :search="search"
                  class="elevation-1"
                  :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
                  rows-per-page-text="Registros por página"
                  no-data-text="Não existem registros"
                  no-results-text="Nenhum registro encontrado"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.data | formatDate }}</td>
                    <td>{{ props.item.id_texto }}</td>
                    <td align="center" style="min-width: 150px">
                      <v-btn
                        icon
                        class="mx-0"
                        @click="editItem(props.item)"
                        :disabled="!hasCondominioAccess('condominio_pessoa', 'update')"
                      >
                        <v-icon color="teal">edit</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        class="mx-0"
                        @click="deleteItem(props.item)"
                        :disabled="!hasCondominioAccess('condominio_pessoa', 'delete')"
                      >
                        <v-icon color="pink">delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                  <template slot="pageText" slot-scope="props">
                    {{ props.pageStart }} - {{ props.pageStop }} de
                    {{ props.itemsLength }}
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>

            <!--Create Edit-->
            <v-layout v-else wrap justify-center align-center>
              <v-flex xs12 md2>
                <p-date
                  :label="translate('table.' + entity + '.field.data')"
                  limitPreviousYears
                  v-model="editedItem.data"
                  name="data"
                  :v_validate="'required'"
                  :as="translate('table.' + entity + '.field.data')"
                ></p-date>
              </v-flex>

              <v-flex xs12 md10>
                <v-text-field
                  :label="translate('table.' + entity + '.field.id_texto')"
                  v-model="editedItem.id_texto"
                ></v-text-field>
              </v-flex>

              <!--Distribuição-->
              <v-flex xs12>
                <span class="headline">Sócios</span>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  :headers="sub_headers"
                  :items="this.editedItem.socios"
                  id="sub_items_table"
                  class="elevation-1"
                  hide-actions
                  no-data-text="Não existem registros"
                  no-results-text="Nenhum registro encontrado"
                >
                  <template slot="items" slot-scope="props">
                    <td>
                      {{ props.item.socio.pessoa.id_texto }}
                    </td>
                    <td>
                      <v-text-field
                        type="number"
                        :label="translate('table.' + entity + '.field.porcentagem')"
                        v-model="props.item.porcentagem"
                      ></v-text-field>
                    </td>
                  </template>

                  <template v-slot:footer>
                    <td class="body-2">Total</td>
                    <td class="body-2">{{ somatorioPorcentagem }}</td>
                  </template>
                </v-data-table>
              </v-flex>

              <v-flex xs12>
                <v-btn class="ml-0 mr-1" color="primary darken-2" :disabled="saving" :loading="saving" @click.native="save()">
                  Salvar
                </v-btn>
                <v-btn class="mx-1" @click.native="close(400)">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import crud from "./../../mixin/crud";
import acl from "./../../mixin/acl";
import PDate from "../shared/PDate";
import Decimal from "decimal.js";

export default {
  components: { PDate },
  mixins: [crud, acl],
  data: () => ({
    entity: "condominio_quadrosocietario",
    dialogQuadroVisible: false,
  }),
  name: "QuadroSocietario",
  props: ["condominio_id", "socios", "values"],
  created() {
    this.items = this.values;
    this.editedItem = {
      condominio_id: this.condominio_id,
      data: "",
      id_texto: "",
      socios: [],
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      data: "",
      id_texto: "",
      socios: [],
    };
  },
  computed: {
    headers: function () {
      return [
        {
          text: this.translate("table." + this.entity + ".field.data"),
          value: "data",
          align: "center",
          width: "30%",
        },
        {
          text: this.translate("table." + this.entity + ".field.id_texto"),
          value: "id_texto",
          width: "70%",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
          width: "10%",
        },
      ];
    },
    sub_headers: function () {
      return [
        {
          text: "Sócio",
          value: "socio.pessoa.id_texto",
        },
        {
          text: "Participação",
          value: "porcentagem",
          sortable: false,
          width: "20%",
        },
      ];
    },
    somatorioPorcentagem: function () {
      let soma = this.editedItem.socios.reduce((total, socio) => {
        return Decimal(total).plus(Decimal(socio.porcentagem));
      }, Decimal(0));

      soma = Decimal(soma.toFixed(15));

      return soma.toString();
    },
  },
  methods: {
    beforeCreate() {
      this.editedItem.socios = this.socios.map((item) => ({
        porcentagem: item.inicialporcentagem,
        condominio_pessoa_id: item.id,
        socio: {
          pessoa: item.pessoa,
        },
      }));
    },
    beforeSave() {
      if (this.somatorioPorcentagem != 100) {
        alert("O somatório da porcentagem deve ser igual a 100.");
        return false;
      }
    },
    afterSave() {
      this.$emit("updateSocios");
    },
    closeDialog() {
      this.dialogQuadroVisible = false;
      this.close();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/details/QuadroSocietario.vue